var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.796,
    height: 28.832,
    viewBox: "0 0 28.796 28.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_zocial-call",
    "data-name": "Icon zocial-call",
    d: "M3.328,8.6a2.121,2.121,0,0,1,.54-1.152l4.32-4.32q.5-.432.756.144l3.492,6.552a.943.943,0,0,1-.18,1.116l-1.584,1.584a1.791,1.791,0,0,0-.5,1.116,5.5,5.5,0,0,0,1.116,2.772,23.672,23.672,0,0,0,2.2,2.881L14.6,20.448c.336.336.767.75,1.3,1.242A21.734,21.734,0,0,0,18.5,23.634a5.839,5.839,0,0,0,2.862,1.206,1.567,1.567,0,0,0,1.152-.468L24.389,22.5a.791.791,0,0,1,1.079-.144l6.3,3.708a.526.526,0,0,1,.288.378.46.46,0,0,1-.144.414l-4.32,4.32a2.116,2.116,0,0,1-1.151.539,8.709,8.709,0,0,1-3.979-.486,18,18,0,0,1-4.1-1.962q-1.89-1.223-3.51-2.483t-2.592-2.16l-.936-.9q-.359-.359-.954-.99T8.3,20.25A36.155,36.155,0,0,1,5.74,16.632a21.106,21.106,0,0,1-1.872-4.014A8.539,8.539,0,0,1,3.328,8.6Z",
    transform: "translate(-3.267 -2.947)",
    fill: "#74ad85"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b0306a02.svg";
export { ForwardRef as ReactComponent };